/*
 * Copyright (c) 2019  Apricad LLC. All Rights Reserved.
 */

import axios from "axios";
import { Action, Dispatch } from "redux";
import { sAccessCourseFail, sGetLicDocFail } from "assets/jss/views/ResStrings";

import {
  GET_CURRENT_INFOBOX,
  GET_LICENSED_CONTENT,
  GET_INFOBOX_FAILED,
  CONTENT_LICENSE_FAILED,
  ApricotActionCreator,
} from "./types";

import {
  currentInfoBoxLoaded,
  pdfContentLoaded,
} from "../selectors/infoboxSelector";

const inTest = process.env.NODE_ENV === "test";

export const getCurrentInfoBox: ApricotActionCreator = (
  ibx_id: string,
) => async (dispatch: Dispatch<any>, getState, api): Promise<Action> => {
  try {
    // call selector with state and mimic props.ibx_id
    if (!inTest && currentInfoBoxLoaded(getState(), { ibx_id })) {
      return Promise.resolve() as any;
    }

    api = api || axios;
    const res = await api.get("/api/ibox/" + ibx_id);

    return dispatch({
      type: GET_CURRENT_INFOBOX,
      payload: res.data,
    });
  } catch (err) {
    return dispatch({
      type: GET_INFOBOX_FAILED,
      payload: sAccessCourseFail,
    });
  }
};

export const getLicensedDoc: ApricotAction = (docInfo) => async (
  dispatch: Dispatch<any>,
  getState,
  api,
): Promise<Action> => {
  try {
    const { docpath, user, email, cr } = docInfo; // cr: copy-right text needed

    if (!inTest && pdfContentLoaded(getState(), { contentLink: docpath })) {
      return Promise.resolve() as any;
    }

    api = api || axios;
    const res = await api.get(
      `/api/file/addLic?user=${user || ""}&email=${
        email || ""
      }&docpath=${docpath}&cr=${cr ? "y" : "n"}`,
    );

    return dispatch({
      type: GET_LICENSED_CONTENT,
      payload: { contentLink: docpath, licensedDoc: res.data },
    });
  } catch (err) {
    return dispatch({
      type: CONTENT_LICENSE_FAILED,
      payload: sGetLicDocFail,
    });
  }
};

export type ApricotAction = ApricotActionCreator;
